export default {
  accountRateSheetDefinitions: (state) => state.rateSheetDefinitions,
  accountRateSheetDefinitionsLoading: (state) => state.rateSheetDefinitionsLoading,
  accountVersionedRateSheetDefinitions: (state) => state.versionedRateSheetDefinitions,
  accountVersionedRateSheetDefinitionsLoading: (state) => state.versionedRateSheetDefinitionsLoading
}
